<template lang="html">
  <div class="form-group my-3">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'My360FormGroup'
}
</script>
